import Icon from '../components/Icon.vue'

Icon.register({
  'shekel-sign': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M248 168c0-30.9-25.1-56-56-56h-112v352c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-408c0-13.3 10.8-24 24-24h168c75.1 0 136 60.9 136 136v168c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-168zM432 32c8.8 0 16 7.2 16 16v296c0 75.1-60.9 136-136 136h-168c-13.3 0-24-10.8-24-24v-280c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v224h112c30.9 0 56-25.1 56-56v-296c0-8.8 7.2-16 16-16h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shekel-sign.js
// module id = 1877
// module chunks = 0